import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarPlus, Copy, RefreshCw } from "lucide-react";

export const CalendarFeedCard = () => {
  const [url, setUrl] = useState("");
  useEffect(() => { api.get("/calendar/feed-link").then((r) => setUrl(r.data.url)).catch(() => {}); }, []);
  const google = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(url.replace(/^https:/, "webcal:"))}`;
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Calendar link copied"); };
  const reset = async () => {
    if (!window.confirm("Make a new link? The old one will stop working in any calendar that uses it.")) return;
    try { setUrl((await api.post("/calendar/feed-link/reset")).data.url); toast.success("New calendar link created"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Card className="mb-5 p-5" data-testid="calendar-feed-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="flex items-center gap-2 font-semibold text-slate-900"><CalendarPlus className="h-4 w-4 text-amber-600" />Add to Google Calendar</h3>
          <p className="mt-1 text-sm text-slate-500">Add once and every appointment Ava books appears with the lead's phone, email, property and Ava's notes. Google refreshes it every few hours. Keep this link private.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button asChild disabled={!url} data-testid="calendar-google-btn"><a href={google} target="_blank" rel="noreferrer">Add to Google Calendar</a></Button>
          <Button variant="outline" onClick={copy} disabled={!url} data-testid="calendar-copy-btn"><Copy className="mr-1 h-4 w-4" />Copy link</Button>
          <Button variant="ghost" onClick={reset} data-testid="calendar-reset-btn"><RefreshCw className="mr-1 h-4 w-4" />New link</Button>
        </div>
      </div>
      <code className="mt-3 block break-all rounded bg-slate-50 px-3 py-2 text-xs text-slate-600" data-testid="calendar-feed-url">{url || "Loading…"}</code>
    </Card>
  );
};
